
// skills images
import SkillImg1 from "./assets/img/skills/Royal-canin.png";
import SkillImg2 from "./assets/img/skills/me-o.png";
import SkillImg3 from "./assets/img/skills/whiskas.png";
import SkillImg4 from "./assets/img/skills/novo.png";
import SkillImg5 from "./assets/img/skills/ricard.png";
import SkillImg6 from "./assets/img/skills/friskies.png";

// projects
export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "Peralatan Kucing",
  },
  {
    name: "Peralatan Anjing",
  },
];

// skill
export const skills = [
  {
    image: SkillImg1,
  },
  {
    image: SkillImg2,
  },
  {
    image: SkillImg3,
  },
  {
    image: SkillImg4,
  },
  {
    image: SkillImg5,
  },
  {
    image: SkillImg6,
  }
];

